import script from "./VerifyUser.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyUser.vue?vue&type=script&setup=true&lang=js"

import "./VerifyUser.vue?vue&type=style&index=0&id=33e466f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e466f1"]])

export default __exports__